import React from 'react';

import withPageComponents from '../../../../page/components/with-page-components';
import useProductPrice from '../../../../hooks/useProductPrice';
import useProductImpressions from '../../../../hooks/useProductImpressionsV2';
import ConsumerFinanceWidget from '../../../../product/components/consumer-finance-widget';
import DeliveryMessage from '../pdp-delivery-message';
import PreOrderDisclaimer from '../pre-order-disclaimer-link';
import StockIndicator from '../stock-indicator';
import CTAWrapper from '../cta';
import PriceBlock from './price-container';
import GiftCardContainer from './gift-card-container';
import { ReviewSection } from '../title-section';
import { useEnrollmentKit } from '../enrollment-kit';
import EnrollmentKitCta, { getEnrollmentKitPriceProps } from './enrollment-kit-cta';
import Offers from './offers';
import CompareSku from '../compare-sku';
import './cart-section.less';

const cartSection = ({
    productInitial,
    productInitialPrice,
    pdpCarePackBundle,
    pdpOfferCatgories,
    pdpShadowCTO,
    templateKey,
    bazaarVoiceProps,
    device,
}) => {
    const { shipDate, sku, product_type, discontinuedMsg } = productInitial || {};
    const { carepacks } = pdpCarePackBundle || {};
    const { offers } = pdpOfferCatgories || {};
    const { prices } = useProductPrice([productInitial, ...(Array.isArray(carepacks) ? carepacks : [])]);
    const ekProps = useEnrollmentKit(productInitial);
    const { kitDisplayPrice, enrollmentKitProps } = ekProps;
    const enrollmentKitEnabled = !!enrollmentKitProps;
    const priceObj = (prices || {})[sku];
    const { backOrderFlag, preOrder, isOOS } = priceObj || {};
    const { shadowCTOEnabled } = pdpShadowCTO || {};
    const hideStockMessage = preOrder || backOrderFlag || shadowCTOEnabled;

    const isOutOfStock = !!priceObj?.isOOS;
    const subscriptionPrices = getEnrollmentKitPriceProps(kitDisplayPrice);
    const priceProps = { subscriptionPrices };
    const productsWithAnalytics = useProductImpressions({
        products: productInitial && [productInitial],
        list: 'pdp',
        componentKey: 'productInitial',
        key: sku,
        isMainSku: true,
        // nonImpression: true,
    });

    const prdInitial = (Array.isArray(productsWithAnalytics) && productsWithAnalytics[0]) || productInitial;

    if (!prdInitial) return null;
    const ctaBtnProps = enrollmentKitEnabled ? { variation: 'secondary' } : {};

    return (
        <div id="addtocart" className={'pdp-cart-section'}>
            {!shadowCTOEnabled && (
                <>
                    <ReviewSection
                        productInitial={productInitial}
                        bazaarVoiceProps={bazaarVoiceProps}
                        templateKey={templateKey}
                        device={device}
                    />
                    <GiftCardContainer>
                        <PriceBlock className="pdp-price-row" priceProps={priceProps} hasPriceSeoText={false} />
                    </GiftCardContainer>
                    <ConsumerFinanceWidget
                        product={prdInitial}
                        price={priceObj || productInitialPrice}
                        variant="section"
                    />
                </>
            )}
            <PreOrderDisclaimer priceObj={priceObj} />
            <CTAWrapper
                hideForShadowCTO={true}
                secondaryCTA={enrollmentKitEnabled ? <EnrollmentKitCta {...ekProps} /> : undefined}
                ctaBtnProps={ctaBtnProps}
                className={enrollmentKitEnabled ? 'enrollment-kit-container' : undefined}
                loaderEnabled={true}
            />
            {isOutOfStock ? (
                <div className="cta-content-divider"></div>
            ) : (
                product_type !== 'CTO' && (
                    <div className="delivery-message-container">
                        {!shadowCTOEnabled && <DeliveryMessage />}
                        {!hideStockMessage && (
                            <StockIndicator
                                showFor={['tablet', 'desktop', 'mobile']}
                                shipDate={shipDate}
                                orionEnabled={true}
                                hideStatus={['inStock']}
                            />
                        )}
                    </div>
                )
            )}
            <Offers offersList={offers} mainProdSku={sku} />
            {!discontinuedMsg && <CompareSku prices={prices} />}
        </div>
    );
};

cartSection.whyDidYouRender = true;

export default withPageComponents(cartSection, {
    components: ['productInitial', 'productInitialPrice', 'pdpCarePackBundle', 'pdpShadowCTO', 'pdpOfferCatgories'],
    device: true,
});
